import { useSelector } from "react-redux";
import colorVariables from "@root/configs/colorVariables";

/**
 * Custom hook that provides the primary color from white-labelling data.
 * Returns the primary color from Redux, with a fallback to default color.
 */
type UsePrimaryColorReturn = {
    defPrimaryColor: string;
    defSecondaryColor: string;
};

export const usePrimaryColor = (): UsePrimaryColorReturn => {
    const { primaryColor, secondaryColor } = useSelector(
        (state: any) => state.whiteLabellingData
    );
    return {
        defPrimaryColor: primaryColor || colorVariables.defaultPrimarycolor,
        defSecondaryColor: secondaryColor || colorVariables.defaultSecondarycolor,
    };
};

export default usePrimaryColor;

